import DialogComponent from "components/Dialog";

export default class CancelAppDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            replaceReasonId: null,
            replaceReasonComment: "",
        };

        this.state = { ...this.defaultState };
    }

    title = "app.cancelReason";

    show(hideCb) {
        this.hidCb = hideCb;
        super.show();
    }

    async save() {
        const { replaceReasonId, replaceReasonComment } = this.state;
        if (!replaceReasonId)
            return;

        if (replaceReasonId === 9 && !replaceReasonComment)
            return this.showError("Заполните причину отмены", "Ошибка отмены");

        this.hide();

        if (this.hidCb?.apply)
            this.hidCb({ ...this.state });
    }

    onTypeChange(id) {
        const replaceReasonId = id;
        const replaceReasonComment = "";

        this.setState({ replaceReasonId, replaceReasonComment });
    }

    onInputChange(value) {
        this.state.replaceReasonComment = value;
    }

    renderContent() {
        const { replaceReasonId } = this.state;

        const items = [...this._config.replaceReasons];
        items.unshift({ id: null, name: "main.notIndicated" });

        return (
            <div className="content flex col gap16">
                {this.insertSelect({
                    translate: true,
                    placeHolder: this.title,
                    showLeftIcon: false,
                    value: replaceReasonId,
                    items,
                    onChange: this.onTypeChange.bind(this)
                })}
                {replaceReasonId === 9 && this.insertTextarea({
                    onChange: this.onInputChange.bind(this)
                })}
            </div>
        );
    }
}
